import { put, select, takeLatest } from 'redux-saga/effects'
import { ExposureConstants } from '../store/exposure.constants'
import { setExposureList } from '../store/exposure.actions'
import { IExposureState } from '../store/exposure.types'
import { getExposureSelector } from '../selectors/getExposure.selector'
import { initialExposure } from '../store/exposure.reducers'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setExposureEquipment() {
  const exposureState: IExposureState = yield select(getExposureSelector)
  const { exposureEquipment, exposureList, crewId } = exposureState
  const selectedExposure = exposureList.find((exp) => exp.crewId === crewId)
  const updatedEquipment = exposureEquipment.map((exp) => ({ ...exp, crewId }))
  try {
    if (selectedExposure) {
      selectedExposure.exposureEquipment = updatedEquipment
      yield put(setExposureList(exposureList))
    } else {
      const copyExposureList = [
        ...exposureList,
        {
          ...initialExposure,
          exposureEquipment: updatedEquipment,
          crewId,
        },
      ]
      yield put(setExposureList(copyExposureList))
    }
  } catch (e) {
    yield put(throwPcrException(`setExposureEquipment() error: ${e}`))
  }
}
export function* setExposureEquipmentSaga() {
  yield takeLatest([ExposureConstants.SET_EXPOSURE_EQUIPMENT], setExposureEquipment)
}
